import React from 'react'
import {Box, ButtonBase, Stack, Typography} from '@mui/material'
import moment from 'moment'
import MuiDatePicker from '@ui/datePicker/muiDatePicker/MuiDatePicker'
import {sx as itemSx} from '@containers/map/containers/navigateMapFeatures/item/sx'
import {IPassengerChartRouteSummary} from '@containers/monitoringPlatform/passengerCharts/types'
import {pluralVypusk} from '@containers/monitoringPlatform/passengerCharts/helpers/pluralVypusk'
import {routeNumber} from '@containers/monitoringPlatform/passengerCharts/helpers/routeNumber'
import {DATE_FORMAT_PASSENGER_CHARTS} from '@containers/monitoringPlatform/passengerCharts/constants'
import sx from '@containers/monitoringPlatform/passengerCharts/sidebar/sx'

const DISPLAY_FORMAT = 'DD.MM.YYYY'

interface IProps {
	date: string
	onChangeDate: (date: string) => void
	routes: IPassengerChartRouteSummary[]
	routeId: number | null
	onSelectRoute: (routeId: number | null) => void
	isLoading: boolean
}

const PassengerChartsSidebar = ({date, onChangeDate, routes, routeId, onSelectRoute, isLoading}: IProps) => {
	return (
		<Stack sx={sx.root}>
			<Typography sx={sx.section}>Дата</Typography>
			<MuiDatePicker
				value={moment(date, DATE_FORMAT_PASSENGER_CHARTS).format(DISPLAY_FORMAT)}
				onChange={(value) => onChangeDate(moment(value, DISPLAY_FORMAT).format(DATE_FORMAT_PASSENGER_CHARTS))}
				format={DISPLAY_FORMAT}
				hasTime={false}
				fullWidth
			/>

			<Typography sx={sx.section}>Маршрути з відстеженням</Typography>

			{!isLoading && !routes.length && <Typography sx={sx.empty}>
				Немає маршрутів з відстеженням за цей день
			</Typography>}

			<Stack gap="6px">
				{routes.map((route) => (
					<ButtonBase
						key={route.routeId}
						className={routeId === route.routeId ? 'active' : undefined}
						sx={sx.link}
						onClick={() => onSelectRoute(route.routeId)}
					>
						<Box sx={itemSx.item}>
							<Box sx={itemSx.iconWrap}>
								<Typography component="span" sx={sx.routeBadge}>
									{routeNumber(route.routeName)}
								</Typography>
							</Box>
							<Box sx={itemSx.text}>
								<Typography sx={itemSx.title}>
									Маршрут №{routeNumber(route.routeName)}
								</Typography>
								<Typography sx={itemSx.description}>
									{route.vypusky.length} {pluralVypusk(route.vypusky.length)}
								</Typography>
							</Box>
						</Box>
					</ButtonBase>
				))}
			</Stack>
		</Stack>
	)
}

export default PassengerChartsSidebar
